import React, { useState } from "react";
import ImageS3 from "../common/ImageS3";
import AuthService from "../../services/owner/AuthService";
import useAuthentication from "../HOC/useAuthentication";
import Conformation from "../common/conformation";
import { formatDeviceValue } from "../../utils/deviceInfo";
import _ from "lodash";

const PassengerTable = ({ owners, tableFor, isedit, handleModal, refresh }) => {
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [expandedRow, setExpandedRow] = useState(null);
  const { user, setUser } = useAuthentication();
  const [visibleConformation, setVisibleConformation] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);

  const [showBanReasonModal, setShowBanReasonModal] = useState(false);
  const [selectedPassenger, setSelectedPassenger] = useState(null);
  const [deviceInfoPassenger, setDeviceInfoPassenger] = useState(null);
  console.log('Owners are', owners)


  const getName = (driveinfo) => {
    if (driveinfo?.name) return driveinfo.name;
    if (driveinfo?.myOwners?.length > 0) return driveinfo.myOwners[0].name;
    return "N/A";
  };

  const isVerified = (driveinfo) => {
    if (tableFor === "driver") return driveinfo?.isVerifiedAsDriver;
    if (tableFor === "passenger") return driveinfo?.isVerified;
    return false;
  };

  // Update the toggleRow function
  const toggleRow = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const handleVerification = (driver) => {
    setSelectedDriver(driver);
    setVisibleConformation(true);
  };

  const BanReasonModal = ({ isOpen, onClose, selectedPassenger }) => {
    const [banReason, setBanReason] = useState(selectedPassenger?.banReason || "");
    const handleBanPassenger = async (passenger, reason) => {
      try {
        const response = await AuthService.banUser(
          {
            userId: passenger?._id,
            banUser: !passenger?.isBanned,
            userType: "passenger",
            reason: reason
          }
        );
        console.log("response", response)
        if (response) {
          onClose();
          refresh();
        }
      } catch (error) {
        console.error("Error banning passenger:", error);
      }
    };

    if (!isOpen) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 w-full max-w-md">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-gray-800">Ban Reason</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <textarea
            value={banReason}
            onChange={(e) => setBanReason(e.target.value)}
            placeholder="Enter reason for banning..."
            className="w-full px-3 py-2 border border-gray-300 rounded-lg min-h-[100px] mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onClose();
                handleBanPassenger(selectedPassenger, banReason);
              }}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              {selectedPassenger?.isBanned ? "Unban Passenger" : "Ban Passenger"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const DeviceInfoModal = ({ passenger, onClose }) => {
    const devices = [...(passenger?.firebaseTokens || [])].sort((a, b) => {
      if (a?.active && !b?.active) return -1;
      if (!a?.active && b?.active) return 1;
      return (
        new Date(b?.lastLoginAt || b?.setDate || 0) -
        new Date(a?.lastLoginAt || a?.setDate || 0)
      );
    });

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div
          className="bg-white rounded-xl shadow-xl w-full max-w-5xl p-6 flex flex-col"
          style={{ maxHeight: "85vh", overflow: "hidden" }}
        >
          <div className="flex items-center justify-between mb-5 flex-shrink-0">
            <div>
              <h2 className="text-xl font-semibold text-gray-800">Device Info</h2>
              <p className="text-sm text-gray-500">
                {passenger?.name || passenger?.mobile || "Passenger"}
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div style={{ overflowY: "auto", paddingRight: 4 }}>
            {!devices.length ? (
              <div className="text-center py-10 text-gray-500 bg-gray-50 rounded-lg">
                No device information found.
              </div>
            ) : (
              <div className="space-y-4">
                {devices.map((device, index) => {
                  const info = device?.deviceInfo || {};
                  const title =
                    [info.brand, info.model].filter(Boolean).join(" ") ||
                    `Device ${index + 1}`;
                  const rows = [
                    ["Status", device?.active ? "Active" : "Inactive"],
                    ["FCM Token", device?.token],
                    ["Login Count", device?.loginCount || 0],
                    [
                      "Last Login",
                      device?.lastLoginAt
                        ? new Date(device.lastLoginAt).toLocaleString()
                        : "N/A",
                    ],
                    [
                      "Token Set Date",
                      device?.setDate
                        ? new Date(device.setDate).toLocaleString()
                        : "N/A",
                    ],
                    ...Object.entries(info).map(([key, value]) => [
                      _.startCase(key),
                      formatDeviceValue(key, value),
                    ]),
                  ];

                  return (
                    <div key={`${device?.token || index}`} className="border border-gray-200 rounded-lg overflow-hidden">
                      <div className="flex items-center justify-between bg-gray-50 px-4 py-3">
                        <div>
                          <h3 className="font-semibold text-gray-900">{title}</h3>
                          <p className="text-sm text-gray-500">
                            {info.systemName || "Unknown OS"} {info.systemVersion || ""}
                          </p>
                        </div>
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${device?.active ? "bg-green-100 text-green-700" : "bg-gray-200 text-gray-700"}`}>
                          {device?.active ? "Active" : "Inactive"}
                        </span>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-gray-200">
                        {rows.map(([label, value]) => (
                          <div key={label} className="bg-white p-3">
                            <p className="text-xs font-medium text-gray-500">{label}</p>
                            <pre className="text-sm text-gray-900 whitespace-pre-wrap break-words font-sans mt-1">
                              {value || "N/A"}
                            </pre>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden  mt-4">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              {["Name", "Phone", "Address", "Driving Car", "OTP", "Trip History", "Device Info", "Action"].map((header) => (
                <th key={header} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {owners.map((item) => (
              <React.Fragment key={item._id}>
                <tr
                  className={`hover:bg-gray-50 ${expandedRow === item._id ? 'bg-blue-50' : ''}`}
                  style={{ backgroundColor: item?.isBanned ? "#FFE6E6" : null }}
                >
                  <td className="px-6 py-4 capitalize">
                    <div className="text-sm font-medium text-gray-900 flex flex-row gap-2 items-center">
                      <p className="font-bold">{getName(item)}</p>
                    </div>
                  </td>
                  {/* <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${isVerified(item) ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
                      }`}>
                      {isVerified(item) ? "Verified" : "Not Verified"}
                    </span>
                  </td> */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">{item?.mobile || "N/A"}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {item?.address?.city && item?.address?.subDistrict
                        ? `${item.address.city}, ${item.address.subDistrict}`
                        : "N/A"}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {item?.assignTrip?.vehicleDetails?.model || "N/A"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {item?.otp || "N/A"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    {isedit && (
                      <button
                        onClick={() => handleModal(true, item)}
                        className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-green-700 bg-green-100 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      >
                        <svg className="h-4 w-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                        View
                      </button>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <button
                      onClick={() => setDeviceInfoPassenger(item)}
                      className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Device Info
                    </button>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    {isedit && (
                      <button
                        onClick={(e) => {
                          setSelectedPassenger(item);
                          setShowBanReasonModal(true);
                        }}
                        className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-red-700 bg-red-200 hover:bg-red-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                      >
                        <svg className="h-4 w-4 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,0,1-8-8A7.92,7.92,0,0,1,5.69,7.1L16.9,18.31A7.92,7.92,0,0,1,12,20Zm6.31-3.1L7.1,5.69A7.92,7.92,0,0,1,12,4a8,8,0,0,1,8,8A7.92,7.92,0,0,1,18.31,16.9Z" />
                        </svg>
                        {item?.isBanned ? "Unban Passenger" : "Ban Passenger"}
                      </button>
                    )}
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      {showBanReasonModal && (
        <BanReasonModal
          isOpen={showBanReasonModal}
          onClose={() => setShowBanReasonModal(false)}
          selectedPassenger={selectedPassenger}
        />
      )}
      {deviceInfoPassenger && (
        <DeviceInfoModal
          passenger={deviceInfoPassenger}
          onClose={() => setDeviceInfoPassenger(null)}
        />
      )}
    </div>
  );
};

export default PassengerTable;
